import React from 'react'
import { FormControl, TextField } from '@mui/material'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
import { BlockFormState } from '../../types'

interface LayoutTabProps {
    kedo: any
    state: BlockFormState
    handleChange: (
        event: React.ChangeEvent<
            HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >
    ) => void
}

const LayoutTab: React.FC<LayoutTabProps> = ({ kedo, state, handleChange }) => (
    <>
        <FormControl fullWidth margin="normal">
            <FormInputLabel>{kedo.t('Column width')}</FormInputLabel>
            <TextField
                size="small"
                name="col"
                value={state.item.col || 12}
                onChange={handleChange}
                error={Boolean(state.errors?.col)}
                helperText={state.errors?.col}
                type="number"
                slotProps={{ htmlInput: { min: 1, max: 12 } }}
            />
        </FormControl>
        <FormControl fullWidth margin="normal">
            <FormInputLabel>{kedo.t('Rank')}</FormInputLabel>
            <TextField
                size="small"
                name="rank"
                value={state.item.rank}
                onChange={handleChange}
                error={Boolean(state.errors?.rank)}
                helperText={state.errors?.rank}
                type="number"
            />
        </FormControl>
    </>
)

export default LayoutTab
